import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  strip() {
    const input = this.element
    const cleaned = input.value.replace(/@/g, '')
    if (cleaned !== input.value) {
      const cursor = input.selectionStart
      const removedBefore = input.value.substring(0, cursor).replace(/@/g, '').length
      input.value = cleaned
      input.setSelectionRange(removedBefore, removedBefore)
    }
  }
}
